import React from 'react';
import { MenuItem, Select } from '@mui/material';
import { FONT_WEIGHT_LIST } from '../themeUtils';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import InputWrapper from './InputWrapper';

const SelectInput = ({inputItem, disabled}) => {
  const formMethods = useFormContext();
  const { control, } = formMethods;
  const option = useWatch({ control, name: `${inputItem.fieldName}` }) || 400;

  return (
    <InputWrapper inputItem={inputItem}>
      <Controller
        control={control}
        name={inputItem.fieldName}
        render={({ field }) => (
          <Select
            {...field}
            id="tp-attribute-select-id"
            variant="outlined"
            displayEmpty
            value={option}
            disabled={disabled}
          >
            {FONT_WEIGHT_LIST.map((item) => {
              return (
                <MenuItem key="true" value={item} style={{fontWeight: item}}>
                  {item}
                </MenuItem>
              );
            })}
          </Select>
        )}
      />
    </InputWrapper>
  );
}

export default SelectInput;